import BaseApi, { BaseApiPromise, ServerListResponse } from '@lumapps/base-api';
import { learningApi } from '@lumapps/learning/constants';
import { TrainingLegacy } from '@lumapps/learning/types';

import { MAX_TRAINING_ENTRIES_PER_QUERY } from '../constants';
import { LearningPaginatedResponse, TrainingPaginatedQuery, TrainingUrlData } from '../types';

/**
 * trainings API.
 */
const trainingsApi = () =>
    new BaseApi({
        version: BaseApi.versions.v2,
        path: 'trainings',
        baseURL: learningApi.URL,
    });

/**
 * catalog parametrized APIs
 * - `catalog/v2/trainings allows to retrieve in-progress or trainings to do
 */
const paths = {
    todo: '/catalog/v2/trainings/todo',
    recommended: '/catalog/v2/trainings/recommended',
    current: '/catalog/v2/trainings/in-progress',
    summaries: '/catalog/v2/trainings/summaries',
    training: (identifier: string) => `catalog/v2/trainings/${identifier}/launch-url`,
    trainingDuel: (identifier: string, activityId?: string, duelId?: string) =>
        `catalog/v2/trainings/${identifier}/launch-url?activityId=${activityId}&duelId=${duelId}`,
};

export const getCurrentTrainings = ({
    language,
    offset = 0,
    limit = MAX_TRAINING_ENTRIES_PER_QUERY + 1,
}: TrainingPaginatedQuery): BaseApiPromise<LearningPaginatedResponse<TrainingLegacy>> => {
    return trainingsApi().get<LearningPaginatedResponse<TrainingLegacy>>(paths.current, {
        params: { language, offset, limit },
    });
};

export const getTrainingsTodo = ({
    language,
    offset = 0,
    limit = MAX_TRAINING_ENTRIES_PER_QUERY + 1,
}: TrainingPaginatedQuery): BaseApiPromise<LearningPaginatedResponse<TrainingLegacy>> => {
    return trainingsApi().get<LearningPaginatedResponse<TrainingLegacy>>(paths.todo, {
        params: { language, offset, limit },
    });
};

export const getTrainingUrl = (
    identifier: string,
    activityId?: string,
    duelId?: string,
): BaseApiPromise<TrainingUrlData> => {
    return trainingsApi().get<TrainingUrlData>(
        activityId && duelId ? paths.trainingDuel(identifier, activityId, duelId) : paths.training(identifier),
    );
};

export const getTrainingSummaries = async (
    params: Record<string, any>,
): Promise<ServerListResponse<TrainingLegacy>> => {
    const { data } = await trainingsApi().get<ServerListResponse<TrainingLegacy>>(paths.summaries, { params });
    return data;
};

export { trainingsApi, paths };
